export const isPDF = (filename: string) => {
  return filename.toLocaleLowerCase().endsWith('.pdf');
};
